import type {
	FieldValues,
	Path,
	PathValue,
	UseFormGetValues,
	UseFormSetValue
} from 'react-hook-form';

type PhoneGroupField<T extends FieldValues> = {
	name: Path<T>;
	value: PathValue<T, Path<T>>;
	onChange: (value: PathValue<T, Path<T>>) => void;
};

export const createPhoneGroupHandlers = <T extends FieldValues>(
	setValue: UseFormSetValue<T>,
	getValues: UseFormGetValues<T>,
	phone: PhoneGroupField<T>,
	countryIso: PhoneGroupField<T>
) => {
	const touch = (field: PhoneGroupField<T>) =>
		setValue(field.name, getValues(field.name), { shouldDirty: true });

	return {
		onCountryIsoChange: (value: string) => {
			countryIso.onChange(value as PathValue<T, Path<T>>);
			touch(phone);
		},
		onPhoneChange: (value: string) => {
			phone.onChange(value as PathValue<T, Path<T>>);
			touch(countryIso);
		}
	};
};
